import { apiClient } from "../api-client";

export function useFeaturedEvents() {
  return apiClient.useQuery(
    "get",
    "/api/public/events",
    {
      params: {
        query: {
          filter: `isFeatured==true;isPublished==true;isCancelled==false`,
          pageSize: 4,
          sort: "startsAt:asc",
          beforeBookingCloses: true,
        },
      },
    },
    {
      staleTime: 1000 * 60 * 5,
    },
  );
}
